const cityCoordinates = {
  "湖北省随州": {
    "lat": 31.717858,
    "lng": 113.379358
  },
  "湖北省恩施土家族苗族自治州": {
    "lat": 30.285888,
    "lng": 109.491923
  },
  "湖南省": {
    "lat": 27.695864,
    "lng": 111.720664
  },
  "湖南省长沙": {
    "lat": 28.213478,
    "lng": 112.979353
  },
  "湖南省株洲": {
    "lat": 27.827433,
    "lng": 113.131695
  },
  "湖南省湘潭": {
    "lat": 27.835095,
    "lng": 112.935556
  },
  "湖南省衡阳": {
    "lat": 26.898164,
    "lng": 112.583819
  },
  "湖南省邵阳": {
    "lat": 27.236811,
    "lng": 111.461525
  },
  "湖南省岳阳": {
    "lat": 29.378007,
    "lng": 113.146196
  },
  "湖北省黄石": {
    "lat": 30.216127,
    "lng": 115.050683
  },
  "湖北省十堰": {
    "lat": 32.636994,
    "lng": 110.801229
  },
  "湖北省宜昌": {
    "lat": 30.732758,
    "lng": 111.310981
  },
  "湖北省襄阳": {
    "lat": 32.229169,
    "lng": 112.250093
  },
  "湖北省鄂州": {
    "lat": 30.384439,
    "lng": 114.895594
  },
  "湖北省荆门": {
    "lat": 31.042611,
    "lng": 112.21733
  },
  "湖北省孝感": {
    "lat": 30.927955,
    "lng": 113.935734
  },
  "湖北省荆州": {
    "lat": 30.332591,
    "lng": 112.241866
  },
  "湖北省黄冈": {
    "lat": 30.446109,
    "lng": 114.906618
  },
  "湖北省咸宁": {
    "lat": 29.880657,
    "lng": 114.300061
  },
  "新疆阿勒泰": {
    "lat": 47.839744,
    "lng": 88.137915
  },
  "香港特别行政区": {
    "lat": 22.293586,
    "lng": 114.186124
  },
  "澳门特别行政区": {
    "lat": 22.204118,
    "lng": 113.557519
  },
  "宁夏中卫": {
    "lat": 37.521124,
    "lng": 105.196754
  },
  "新疆乌鲁木齐": {
    "lat": 43.84038,
    "lng": 87.564988
  },
  "新疆克拉玛依": {
    "lat": 45.594331,
    "lng": 84.88118
  },
  "新疆克拉玛依市吐鲁番": {
    "lat": 45.594331,
    "lng": 84.88118
  },
  "新疆哈密": {
    "lat": 42.858596,
    "lng": 93.528355
  },
  "新疆昌吉回族自治州": {
    "lat": 44.007058,
    "lng": 87.296038
  },
  "新疆博尔塔拉蒙古自治州": {
    "lat": 44.913651,
    "lng": 82.052436
  },
  "新疆巴音郭楞蒙古自治州": {
    "lat": 41.771362,
    "lng": 86.121688
  },
  "新疆阿克苏": {
    "lat": 41.171731,
    "lng": 80.269846
  },
  "新疆克孜勒苏柯尔克孜自治州": {
    "lat": 39.750346,
    "lng": 76.137564
  },
  "新疆喀什": {
    "lat": 39.470627,
    "lng": 75.992973
  },
  "北京": {
    "lat": 39.9,
    "lng": 116.4
  },
  "北京市县": {
    "lat": 39.929986,
    "lng": 116.395645
  },
  "天津": {
    "lat": 39.08,
    "lng": 117.2
  },
  "天津市县": {
    "lat": 39.14393,
    "lng": 117.210813
  },
  "河北省": {
    "lat": 38.61384,
    "lng": 115.661434
  },
  "河北省石家庄": {
    "lat": 38.048958,
    "lng": 114.522082
  },
  "河北省唐山": {
    "lat": 39.650531,
    "lng": 118.183451
  },
  "河北省秦皇岛": {
    "lat": 39.945462,
    "lng": 119.604368
  },
  "河北省邯郸": {
    "lat": 36.609308,
    "lng": 114.482694
  },
  "湖南省常德": {
    "lat": 29.012149,
    "lng": 111.653718
  },
  "湖南省张家界": {
    "lat": 29.124889,
    "lng": 110.48162
  },
  "湖南省益阳": {
    "lat": 28.588088,
    "lng": 112.366547
  },
  "湖南省郴州": {
    "lat": 25.782264,
    "lng": 113.037704
  },
  "湖南省永州": {
    "lat": 26.435972,
    "lng": 111.614648
  },
  "湖南省怀化": {
    "lat": 27.557483,
    "lng": 109.986959
  },
  "湖南省娄底": {
    "lat": 27.741073,
    "lng": 111.996396
  },
  "湖南省湘西土家族苗族自治州": {
    "lat": 28.317951,
    "lng": 109.745746
  },
  "广东省": {
    "lat": 23.408004,
    "lng": 113.394818
  },
  "广东省广州": {
    "lat": 23.120049,
    "lng": 113.30765
  },
  "广东省韶关": {
    "lat": 24.80296,
    "lng": 113.594461
  },
  "广东省阳江": {
    "lat": 21.871517,
    "lng": 111.97701
  },
  "广东省清远": {
    "lat": 23.698469,
    "lng": 113.040773
  },
  "广东省东莞": {
    "lat": 23.043024,
    "lng": 113.763434
  },
  "广东省中山": {
    "lat": 22.545178,
    "lng": 113.42206
  },
  "广东省潮州": {
    "lat": 23.661812,
    "lng": 116.630076
  },
  "广东省揭阳": {
    "lat": 23.547999,
    "lng": 116.379501
  },
  "广东省云浮": {
    "lat": 22.937976,
    "lng": 112.050946
  },
  "广西南宁": {
    "lat": 22.806493,
    "lng": 108.297234
  },
  "广西柳州": {
    "lat": 24.329053,
    "lng": 109.422402
  },
  "广西桂林": {
    "lat": 25.262901,
    "lng": 110.26092
  },
  "广西梧州": {
    "lat": 23.485395,
    "lng": 111.305472
  },
  "广西北海": {
    "lat": 21.472718,
    "lng": 109.122628
  },
  "广西防城港": {
    "lat": 21.617398,
    "lng": 108.351791
  },
  "广西钦州": {
    "lat": 21.97335,
    "lng": 108.638798
  },
  "广西贵港": {
    "lat": 23.103373,
    "lng": 109.613708
  },
  "广西玉林": {
    "lat": 22.643974,
    "lng": 110.151676
  },
  "广西百色": {
    "lat": 23.901512,
    "lng": 106.631821
  },
  "广西贺州": {
    "lat": 24.411054,
    "lng": 111.552594
  },
  "广西河池": {
    "lat": 24.699521,
    "lng": 108.069948
  },
  "广西来宾": {
    "lat": 23.741166,
    "lng": 109.231817
  },
  "广西崇左": {
    "lat": 22.415455,
    "lng": 107.357322
  },
  "海南省": {
    "lat": 19.180501,
    "lng": 109.733755
  },
  "海南省海口": {
    "lat": 20.022071,
    "lng": 110.330802
  },
  "海南省三亚": {
    "lat": 18.257776,
    "lng": 109.522771
  },
  "重庆": {
    "lat": 29.56,
    "lng": 106.55
  },
  "重庆市县": {
    "lat": 29.544606,
    "lng": 106.530635
  },
  "重庆市": {
    "lat": 29.544606,
    "lng": 106.530635
  },
  "四川省": {
    "lat": 30.367481,
    "lng": 102.89916
  },
  "四川省成都": {
    "lat": 30.679943,
    "lng": 104.067923
  },
  "四川省自贡": {
    "lat": 29.359157,
    "lng": 104.776071
  },
  "四川省攀枝花": {
    "lat": 26.587571,
    "lng": 101.722423
  },
  "四川省泸州": {
    "lat": 28.89593,
    "lng": 105.44397
  },
  "四川省德阳": {
    "lat": 31.13114,
    "lng": 104.402398
  },
  "四川省绵阳": {
    "lat": 31.504701,
    "lng": 104.705519
  },
  "四川省广元": {
    "lat": 32.44104,
    "lng": 105.819687
  },
  "四川省遂宁": {
    "lat": 30.557491,
    "lng": 105.564888
  },
  "四川省内江": {
    "lat": 29.599462,
    "lng": 105.073056
  },
  "四川省乐山": {
    "lat": 29.600958,
    "lng": 103.760824
  },
  "四川省南充": {
    "lat": 30.800965,
    "lng": 106.105554
  },
  "四川省眉山": {
    "lat": 30.061115,
    "lng": 103.84143
  },
  "四川省宜宾": {
    "lat": 28.769675,
    "lng": 104.633019
  },
  "四川省广安": {
    "lat": 30.463984,
    "lng": 106.63572
  },
  "四川省达州": {
    "lat": 31.214199,
    "lng": 107.494973
  },
  "四川省雅安": {
    "lat": 29.999716,
    "lng": 103.009356
  },
  "四川省巴中": {
    "lat": 31.869189,
    "lng": 106.757916
  },
  "四川省资阳": {
    "lat": 30.132191,
    "lng": 104.63593
  },
  "四川省阿坝藏族羌族自治州": {
    "lat": 31.905763,
    "lng": 102.228565
  },
  "四川省甘孜藏族自治州": {
    "lat": 30.055144,
    "lng": 101.969232
  },
  "四川省凉山彝族自治州": {
    "lat": 27.892393,
    "lng": 102.259591
  },
  "贵州省": {
    "lat": 26.902826,
    "lng": 106.734996
  },
  "贵州省贵阳": {
    "lat": 26.629907,
    "lng": 106.709177
  },
  "贵州省六盘水": {
    "lat": 26.591866,
    "lng": 104.852087
  },
  "贵州省遵义": {
    "lat": 27.699961,
    "lng": 106.93126
  },
  "贵州省安顺": {
    "lat": 26.228595,
    "lng": 105.92827
  },
  "新疆和田": {
    "lat": 37.116774,
    "lng": 79.930239
  },
  "新疆伊犁哈萨克自治州": {
    "lat": 43.922248,
    "lng": 81.297854
  },
  "新疆塔城": {
    "lat": 46.758684,
    "lng": 82.974881
  },
  "甘肃省临夏回族自治州": {
    "lat": 35.598514,
    "lng": 103.215249
  },
  "甘肃省甘南藏族自治州": {
    "lat": 34.992211,
    "lng": 102.917442
  },
  "青海省": {
    "lat": 35.499761,
    "lng": 96.202544
  },
  "青海省西宁": {
    "lat": 36.640739,
    "lng": 101.767921
  },
  "青海省海东": {
    "lat": 36.51761,
    "lng": 102.085207
  },
  "青海省海北藏族自治州": {
    "lat": 36.960654,
    "lng": 100.879802
  },
  "青海省黄南藏族自治州": {
    "lat": 35.522852,
    "lng": 102.0076
  },
  "青海省海南藏族自治州": {
    "lat": 36.284364,
    "lng": 100.624066
  },
  "青海省果洛藏族自治州": {
    "lat": 34.480485,
    "lng": 100.223723
  },
  "青海省玉树藏族自治州": {
    "lat": 33.00624,
    "lng": 97.013316
  },
  "青海省海西蒙古族藏族自治州": {
    "lat": 37.373799,
    "lng": 97.342625
  },
  "宁夏银川": {
    "lat": 38.502621,
    "lng": 106.206479
  },
  "宁夏石嘴山": {
    "lat": 39.020223,
    "lng": 106.379337
  },
  "宁夏吴忠": {
    "lat": 37.993561,
    "lng": 106.208254
  },
  "宁夏固原": {
    "lat": 36.021523,
    "lng": 106.285268
  },
  "广东省深圳": {
    "lat": 22.546054,
    "lng": 114.025974
  },
  "广东省珠海": {
    "lat": 22.256915,
    "lng": 113.562447
  },
  "广东省汕头": {
    "lat": 23.383908,
    "lng": 116.72865
  },
  "广东省佛山": {
    "lat": 23.035095,
    "lng": 113.134026
  },
  "广东省江门": {
    "lat": 22.575117,
    "lng": 113.078125
  },
  "广东省湛江": {
    "lat": 21.257463,
    "lng": 110.365067
  },
  "广东省茂名": {
    "lat": 21.668226,
    "lng": 110.931245
  },
  "广东省肇庆": {
    "lat": 23.078663,
    "lng": 112.479653
  },
  "广东省惠州": {
    "lat": 23.11354,
    "lng": 114.410658
  },
  "广东省梅州": {
    "lat": 24.304571,
    "lng": 116.126403
  },
  "广东省汕尾": {
    "lat": 22.778731,
    "lng": 115.372924
  },
  "广东省河源": {
    "lat": 23.757251,
    "lng": 114.713721
  },
  "河北省廊坊": {
    "lat": 39.518611,
    "lng": 116.703602
  },
  "河北省衡水": {
    "lat": 37.746929,
    "lng": 115.686229
  },
  "山西省": {
    "lat": 37.866566,
    "lng": 112.515496
  },
  "山西省太原": {
    "lat": 37.890277,
    "lng": 112.550864
  },
  "山西省大同": {
    "lat": 40.113744,
    "lng": 113.290509
  },
  "山西省阳泉": {
    "lat": 37.869529,
    "lng": 113.569238
  },
  "山西省长治": {
    "lat": 36.201664,
    "lng": 113.120292
  },
  "山西省晋城": {
    "lat": 35.499834,
    "lng": 112.867333
  },
  "山西省朔州": {
    "lat": 39.337672,
    "lng": 112.479928
  },
  "山西省晋中": {
    "lat": 37.693362,
    "lng": 112.738514
  },
  "山西省运城": {
    "lat": 35.038859,
    "lng": 111.006854
  },
  "山西省忻州": {
    "lat": 38.461031,
    "lng": 112.727939
  },
  "山西省临汾": {
    "lat": 36.099745,
    "lng": 111.538788
  },
  "山西省吕梁": {
    "lat": 37.527316,
    "lng": 111.143157
  },
  "内蒙古呼和浩特": {
    "lat": 40.828319,
    "lng": 111.660351
  },
  "内蒙古包头": {
    "lat": 40.647119,
    "lng": 109.846239
  },
  "内蒙古乌海": {
    "lat": 39.683177,
    "lng": 106.831999
  },
  "内蒙古赤峰": {
    "lat": 42.297112,
    "lng": 118.930761
  },
  "内蒙古通辽": {
    "lat": 43.633756,
    "lng": 122.260363
  },
  "内蒙古鄂尔多斯": {
    "lat": 39.81649,
    "lng": 109.993706
  },
  "内蒙古呼伦贝尔": {
    "lat": 49.201636,
    "lng": 119.760822
  },
  "内蒙古巴彦淖尔": {
    "lat": 40.76918,
    "lng": 107.423807
  },
  "内蒙古乌兰察布": {
    "lat": 41.022363,
    "lng": 113.112846
  },
  "内蒙古兴安": {
    "lat": 43.468238,
    "lng": 114.415868
  },
  "内蒙古锡林郭勒": {
    "lat": 43.468238,
    "lng": 114.415868
  },
  "内蒙古阿拉善": {
    "lat": 43.468238,
    "lng": 114.415868
  },
  "辽宁省": {
    "lat": 41.6216,
    "lng": 122.753592
  },
  "辽宁省沈阳": {
    "lat": 41.808645,
    "lng": 123.432791
  },
  "辽宁省大连": {
    "lat": 38.94871,
    "lng": 121.593478
  },
  "辽宁省鞍山": {
    "lat": 41.118744,
    "lng": 123.007763
  },
  "辽宁省抚顺": {
    "lat": 41.877304,
    "lng": 123.92982
  },
  "辽宁省本溪": {
    "lat": 41.325838,
    "lng": 123.778062
  },
  "辽宁省丹东": {
    "lat": 40.129023,
    "lng": 124.338543
  },
  "辽宁省锦州": {
    "lat": 41.130879,
    "lng": 121.147749
  },
  "辽宁省营口": {
    "lat": 40.668651,
    "lng": 122.233391
  },
  "辽宁省阜新": {
    "lat": 42.01925,
    "lng": 121.660822
  },
  "辽宁省辽阳": {
    "lat": 41.273339,
    "lng": 123.172451
  },
  "辽宁省盘锦": {
    "lat": 41.141248,
    "lng": 122.073228
  },
  "辽宁省铁岭": {
    "lat": 42.299757,
    "lng": 123.85485
  },
  "辽宁省朝阳": {
    "lat": 41.571828,
    "lng": 120.446163
  },
  "辽宁省葫芦岛": {
    "lat": 40.74303,
    "lng": 120.860758
  },
  "吉林省": {
    "lat": 43.678846,
    "lng": 126.262876
  },
  "吉林省长春": {
    "lat": 43.898338,
    "lng": 125.313642
  },
  "吉林省吉林": {
    "lat": 43.871988,
    "lng": 126.564544
  },
  "吉林省四平": {
    "lat": 43.175525,
    "lng": 124.391382
  },
  "吉林省辽源": {
    "lat": 42.923303,
    "lng": 125.133686
  },
  "吉林省通化": {
    "lat": 41.736397,
    "lng": 125.94265
  },
  "吉林省白山": {
    "lat": 41.945859,
    "lng": 126.435798
  },
  "吉林省松原": {
    "lat": 45.136049,
    "lng": 124.832995
  },
  "吉林省白城": {
    "lat": 45.621086,
    "lng": 122.840777
  },
  "吉林省延边朝鲜族自治州": {
    "lat": 42.896414,
    "lng": 129.485902
  },
  "黑龙江省": {
    "lat": 47.356592,
    "lng": 128.047414
  },
  "黑龙江省哈尔滨": {
    "lat": 45.773225,
    "lng": 126.657717
  },
  "河北省邢台": {
    "lat": 37.069531,
    "lng": 114.520487
  },
  "河北省保定": {
    "lat": 38.886565,
    "lng": 115.49481
  },
  "河北省张家口": {
    "lat": 40.811188,
    "lng": 114.893782
  },
  "河北省承德": {
    "lat": 40.992521,
    "lng": 117.933822
  },
  "河北省沧州": {
    "lat": 38.297615,
    "lng": 116.863806
  },
  "黑龙江省齐齐哈尔": {
    "lat": 47.3477,
    "lng": 123.987289
  },
  "黑龙江省鸡西": {
    "lat": 45.32154,
    "lng": 130.941767
  },
  "黑龙江省鹤岗": {
    "lat": 47.338666,
    "lng": 130.292472
  },
  "黑龙江省双鸭山": {
    "lat": 46.655102,
    "lng": 131.171402
  },
  "黑龙江省大庆": {
    "lat": 46.596709,
    "lng": 125.02184
  },
  "黑龙江省伊春": {
    "lat": 47.734685,
    "lng": 128.910766
  },
  "黑龙江省佳木斯": {
    "lat": 46.81378,
    "lng": 130.284735
  },
  "黑龙江省七台河": {
    "lat": 45.775005,
    "lng": 131.019048
  },
  "黑龙江省牡丹江": {
    "lat": 44.588521,
    "lng": 129.608035
  },
  "黑龙江省黑河": {
    "lat": 50.25069,
    "lng": 127.50083
  },
  "黑龙江省绥化": {
    "lat": 46.646064,
    "lng": 126.989095
  },
  "黑龙江省大兴安岭": {
    "lat": 51.991789,
    "lng": 124.196104
  },
  "上海": {
    "lat": 31.23,
    "lng": 121.47
  },
  "上海市县": {
    "lat": 31.249162,
    "lng": 121.487899
  },
  "江苏省": {
    "lat": 33.013797,
    "lng": 119.368489
  },
  "江苏省南京": {
    "lat": 32.057236,
    "lng": 118.778074
  },
  "江苏省无锡": {
    "lat": 31.570037,
    "lng": 120.305456
  },
  "江苏省徐州": {
    "lat": 34.271553,
    "lng": 117.188107
  },
  "江苏省常州": {
    "lat": 31.771397,
    "lng": 119.981861
  },
  "江苏省苏州": {
    "lat": 31.317987,
    "lng": 120.619907
  },
  "江苏省南通": {
    "lat": 32.014665,
    "lng": 120.873801
  },
  "江苏省连云港": {
    "lat": 34.601549,
    "lng": 119.173872
  },
  "江苏省淮安": {
    "lat": 33.606513,
    "lng": 119.030186
  },
  "江苏省盐城": {
    "lat": 33.379862,
    "lng": 120.148872
  },
  "江苏省扬州": {
    "lat": 32.408505,
    "lng": 119.427778
  },
  "江苏省镇江": {
    "lat": 32.204409,
    "lng": 119.455835
  },
  "江苏省泰州": {
    "lat": 32.476053,
    "lng": 119.919606
  },
  "江苏省宿迁": {
    "lat": 33.95205,
    "lng": 118.296893
  },
  "浙江省": {
    "lat": 29.159494,
    "lng": 119.957202
  },
  "浙江省杭州": {
    "lat": 30.259244,
    "lng": 120.219375
  },
  "浙江省宁波": {
    "lat": 29.885259,
    "lng": 121.579006
  },
  "浙江省温州": {
    "lat": 28.002838,
    "lng": 120.690635
  },
  "浙江省嘉兴": {
    "lat": 30.773992,
    "lng": 120.760428
  },
  "浙江省湖州": {
    "lat": 30.877925,
    "lng": 120.137243
  },
  "浙江省绍兴": {
    "lat": 30.002365,
    "lng": 120.592467
  },
  "浙江省金华": {
    "lat": 29.102899,
    "lng": 119.652576
  },
  "浙江省衢州": {
    "lat": 28.95691,
    "lng": 118.875842
  },
  "浙江省舟山": {
    "lat": 30.03601,
    "lng": 122.169872
  },
  "浙江省台州": {
    "lat": 28.668283,
    "lng": 121.440613
  },
  "浙江省丽水": {
    "lat": 28.4563,
    "lng": 119.929576
  },
  "安徽省": {
    "lat": 31.859252,
    "lng": 117.216005
  },
  "安徽省合肥": {
    "lat": 31.866942,
    "lng": 117.282699
  },
  "安徽省芜湖": {
    "lat": 31.36602,
    "lng": 118.384108
  },
  "安徽省蚌埠": {
    "lat": 32.929499,
    "lng": 117.35708
  },
  "安徽省淮南": {
    "lat": 32.642812,
    "lng": 117.018639
  },
  "安徽省马鞍山": {
    "lat": 31.688528,
    "lng": 118.515882
  },
  "安徽省淮北": {
    "lat": 33.960023,
    "lng": 116.791447
  },
  "安徽省铜陵": {
    "lat": 30.94093,
    "lng": 117.819429
  },
  "安徽省安庆": {
    "lat": 30.537898,
    "lng": 117.058739
  },
  "安徽省黄山": {
    "lat": 29.734435,
    "lng": 118.29357
  },
  "安徽省滁州": {
    "lat": 32.317351,
    "lng": 118.32457
  },
  "安徽省阜阳": {
    "lat": 32.901211,
    "lng": 115.820932
  },
  "安徽省宿州": {
    "lat": 33.636772,
    "lng": 116.988692
  },
  "安徽省巢湖": {
    "lat": 31.608733,
    "lng": 117.88049
  },
  "安徽省六安": {
    "lat": 31.755558,
    "lng": 116.505253
  },
  "安徽省亳州": {
    "lat": 33.871211,
    "lng": 115.787928
  },
  "安徽省池州": {
    "lat": 30.660019,
    "lng": 117.494477
  },
  "安徽省宣城": {
    "lat": 30.951642,
    "lng": 118.752096
  },
  "福建省": {
    "lat": 26.050118,
    "lng": 117.984943
  },
  "福建省福州": {
    "lat": 26.047125,
    "lng": 119.330221
  },
  "福建省厦门": {
    "lat": 24.489231,
    "lng": 118.103886
  },
  "福建省莆田": {
    "lat": 25.44845,
    "lng": 119.077731
  },
  "福建省三明": {
    "lat": 26.270835,
    "lng": 117.642194
  },
  "福建省泉州": {
    "lat": 24.901652,
    "lng": 118.600362
  },
  "福建省漳州": {
    "lat": 24.517065,
    "lng": 117.676205
  },
  "福建省南平": {
    "lat": 26.643626,
    "lng": 118.181883
  },
  "福建省龙岩": {
    "lat": 25.078685,
    "lng": 117.017997
  },
  "福建省宁德": {
    "lat": 26.656527,
    "lng": 119.542082
  },
  "江西省": {
    "lat": 27.757258,
    "lng": 115.676082
  },
  "江西省南昌": {
    "lat": 28.689578,
    "lng": 115.893528
  },
  "江西省景德镇": {
    "lat": 29.303563,
    "lng": 117.186523
  },
  "江西省萍乡": {
    "lat": 27.639544,
    "lng": 113.859917
  },
  "江西省九江": {
    "lat": 29.71964,
    "lng": 115.999848
  },
  "江西省新余": {
    "lat": 27.822322,
    "lng": 114.947117
  },
  "江西省鹰潭": {
    "lat": 28.24131,
    "lng": 117.03545
  },
  "江西省赣州": {
    "lat": 25.845296,
    "lng": 114.935909
  },
  "江西省吉安": {
    "lat": 27.113848,
    "lng": 114.992039
  },
  "江西省宜春": {
    "lat": 27.81113,
    "lng": 114.400039
  },
  "江西省抚州": {
    "lat": 27.954545,
    "lng": 116.360919
  },
  "江西省上饶": {
    "lat": 28.457623,
    "lng": 117.955464
  },
  "山东省": {
    "lat": 36.09929,
    "lng": 118.527663
  },
  "山东省济南": {
    "lat": 36.682785,
    "lng": 117.024967
  },
  "山东省青岛": {
    "lat": 36.105215,
    "lng": 120.384428
  },
  "山东省淄博": {
    "lat": 36.804685,
    "lng": 118.059134
  },
  "山东省枣庄": {
    "lat": 34.807883,
    "lng": 117.279305
  },
  "山东省东营": {
    "lat": 37.487121,
    "lng": 118.583926
  },
  "山东省烟台": {
    "lat": 37.536562,
    "lng": 121.309555
  },
  "山东省潍坊": {
    "lat": 36.716115,
    "lng": 119.142634
  },
  "山东省济宁": {
    "lat": 35.402122,
    "lng": 116.600798
  },
  "山东省泰安": {
    "lat": 36.188078,
    "lng": 117.089415
  },
  "山东省威海": {
    "lat": 37.528787,
    "lng": 122.093958
  },
  "山东省日照": {
    "lat": 35.420225,
    "lng": 119.50718
  },
  "山东省莱芜": {
    "lat": 36.233654,
    "lng": 117.684667
  },
  "山东省临沂": {
    "lat": 35.072409,
    "lng": 118.340768
  },
  "山东省德州": {
    "lat": 37.460826,
    "lng": 116.328161
  },
  "山东省聊城": {
    "lat": 36.455829,
    "lng": 115.986869
  },
  "山东省滨州": {
    "lat": 37.405314,
    "lng": 117.968292
  },
  "山东省菏泽": {
    "lat": 35.26244,
    "lng": 115.46336
  },
  "河南省": {
    "lat": 34.157184,
    "lng": 113.486804
  },
  "河南省郑州": {
    "lat": 34.75661,
    "lng": 113.649644
  },
  "河南省开封": {
    "lat": 34.801854,
    "lng": 114.351642
  },
  "河南省洛阳": {
    "lat": 34.657368,
    "lng": 112.447525
  },
  "河南省平顶山": {
    "lat": 33.745301,
    "lng": 113.300849
  },
  "河南省安阳": {
    "lat": 36.110267,
    "lng": 114.351807
  },
  "河南省鹤壁": {
    "lat": 35.755426,
    "lng": 114.29777
  },
  "河南省新乡": {
    "lat": 35.307258,
    "lng": 113.91269
  },
  "河南省焦作": {
    "lat": 35.234608,
    "lng": 113.211836
  },
  "河南省濮阳": {
    "lat": 35.753298,
    "lng": 115.026627
  },
  "河南省许昌": {
    "lat": 34.02674,
    "lng": 113.835312
  },
  "河南省漯河": {
    "lat": 33.576279,
    "lng": 114.046061
  },
  "河南省三门峡": {
    "lat": 34.78332,
    "lng": 111.181262
  },
  "河南省南阳": {
    "lat": 33.01142,
    "lng": 112.542842
  },
  "河南省商丘": {
    "lat": 34.438589,
    "lng": 115.641886
  },
  "河南省信阳": {
    "lat": 32.128582,
    "lng": 114.085491
  },
  "河南省周口": {
    "lat": 33.623741,
    "lng": 114.654102
  },
  "河南省驻马店": {
    "lat": 32.983158,
    "lng": 114.049154
  },
  "湖北省": {
    "lat": 31.209316,
    "lng": 112.410562
  },
  "湖北省武汉": {
    "lat": 30.581084,
    "lng": 114.3162
  },
  "贵州省铜仁": {
    "lat": 27.726271,
    "lng": 109.196161
  },
  "贵州省黔西南布依族苗族自治州": {
    "lat": 25.095148,
    "lng": 104.900558
  },
  "贵州省毕节": {
    "lat": 27.302612,
    "lng": 105.300492
  },
  "贵州省黔东南苗族侗族自治州": {
    "lat": 26.583992,
    "lng": 107.985353
  },
  "贵州省黔南布依族苗族自治州": {
    "lat": 26.264536,
    "lng": 107.523205
  },
  "云南省": {
    "lat": 24.864213,
    "lng": 101.592952
  },
  "云南省昆明": {
    "lat": 25.049153,
    "lng": 102.714601
  },
  "云南省曲靖": {
    "lat": 25.520758,
    "lng": 103.782539
  },
  "云南省玉溪": {
    "lat": 24.370447,
    "lng": 102.545068
  },
  "云南省保山": {
    "lat": 25.120489,
    "lng": 99.177996
  },
  "云南省昭通": {
    "lat": 27.340633,
    "lng": 103.725021
  },
  "云南省丽江": {
    "lat": 26.875351,
    "lng": 100.229628
  },
  "云南省普洱": {
    "lat": 22.788778,
    "lng": 100.980058
  },
  "云南省临沧": {
    "lat": 23.887806,
    "lng": 100.092613
  },
  "云南省楚雄彝族自治州": {
    "lat": 25.066356,
    "lng": 101.529382
  },
  "云南省红河哈尼族彝族自治州": {
    "lat": 23.367718,
    "lng": 103.384065
  },
  "云南省文山壮族苗族自治州": {
    "lat": 23.374087,
    "lng": 104.246294
  },
  "云南省西双版纳傣族自治州": {
    "lat": 22.009433,
    "lng": 100.803038
  },
  "云南省大理白族自治州": {
    "lat": 25.5969,
    "lng": 100.223675
  },
  "云南省德宏傣族景颇族自治州": {
    "lat": 24.44124,
    "lng": 98.589434
  },
  "云南省怒江傈僳族自治州": {
    "lat": 25.860677,
    "lng": 98.859932
  },
  "云南省迪庆藏族自治州": {
    "lat": 27.831029,
    "lng": 99.713682
  },
  "西藏拉萨": {
    "lat": 29.662557,
    "lng": 91.111891
  },
  "西藏昌都": {
    "lat": 31.140576,
    "lng": 97.185582
  },
  "西藏山南": {
    "lat": 29.229027,
    "lng": 91.750644
  },
  "西藏日喀则": {
    "lat": 29.269023,
    "lng": 88.891486
  },
  "西藏那曲": {
    "lat": 31.48068,
    "lng": 92.067018
  },
  "西藏阿里": {
    "lat": 30.404557,
    "lng": 81.107669
  },
  "西藏林芝": {
    "lat": 29.666941,
    "lng": 94.349985
  },
  "陕西省": {
    "lat": 35.860026,
    "lng": 109.503789
  },
  "陕西省西安": {
    "lat": 34.2778,
    "lng": 108.953098
  },
  "陕西省铜川": {
    "lat": 34.908368,
    "lng": 108.968067
  },
  "陕西省宝鸡": {
    "lat": 34.364081,
    "lng": 107.170645
  },
  "陕西省咸阳": {
    "lat": 34.345373,
    "lng": 108.707509
  },
  "陕西省渭南": {
    "lat": 34.502358,
    "lng": 109.483933
  },
  "陕西省延安": {
    "lat": 36.60332,
    "lng": 109.50051
  },
  "陕西省汉中": {
    "lat": 33.081569,
    "lng": 107.045478
  },
  "陕西省榆林": {
    "lat": 38.279439,
    "lng": 109.745926
  },
  "陕西省安康": {
    "lat": 32.70437,
    "lng": 109.038045
  },
  "陕西省商洛": {
    "lat": 33.873907,
    "lng": 109.934208
  },
  "甘肃省": {
    "lat": 38.103267,
    "lng": 102.457625
  },
  "甘肃省兰州": {
    "lat": 36.064226,
    "lng": 103.823305
  },
  "甘肃省嘉峪关": {
    "lat": 39.802397,
    "lng": 98.281635
  },
  "甘肃省金昌": {
    "lat": 38.516072,
    "lng": 102.208126
  },
  "甘肃省白银": {
    "lat": 36.546682,
    "lng": 104.171241
  },
  "甘肃省天水": {
    "lat": 34.584319,
    "lng": 105.736932
  },
  "甘肃省武威": {
    "lat": 37.933172,
    "lng": 102.640147
  },
  "甘肃省张掖": {
    "lat": 38.93932,
    "lng": 100.459892
  },
  "甘肃省平凉": {
    "lat": 35.55011,
    "lng": 106.688911
  },
  "甘肃省酒泉": {
    "lat": 39.741474,
    "lng": 98.508415
  },
  "甘肃省庆阳": {
    "lat": 35.726801,
    "lng": 107.644227
  },
  "甘肃省定西": {
    "lat": 35.586056,
    "lng": 104.626638
  },
  "甘肃省陇南": {
    "lat": 33.39448,
    "lng": 104.934573
  },
  "香港": {
    "lat": 22.31,
    "lng": 114.16
  },
  "澳门": {
    "lat": 22.19,
    "lng": 113.54
  },
  "基隆": {
    "lat": 25.13,
    "lng": 121.74
  },
  "台北": {
    "lat": 25.03,
    "lng": 121.56
  },
  "新北": {
    "lat": 25.01,
    "lng": 121.46
  },
  "桃園": {
    "lat": 24.99,
    "lng": 121.3
  },
  "新竹": {
    "lat": 24.81,
    "lng": 120.96
  },
  "苗栗": {
    "lat": 24.56,
    "lng": 120.82
  },
  "台中": {
    "lat": 24.14,
    "lng": 120.67
  },
  "彰化": {
    "lat": 24.05,
    "lng": 120.51
  },
  "南投": {
    "lat": 23.91,
    "lng": 120.68
  },
  "雲林": {
    "lat": 23.7,
    "lng": 120.54
  },
  "嘉義": {
    "lat": 23.48,
    "lng": 120.44
  },
  "台南": {
    "lat": 22.99,
    "lng": 120.21
  },
  "高雄": {
    "lat": 22.62,
    "lng": 120.31
  },
  "屏東": {
    "lat": 22.67,
    "lng": 120.48
  },
  "台東": {
    "lat": 22.75,
    "lng": 121.14
  },
  "花蓮": {
    "lat": 23.98,
    "lng": 121.6
  },
  "宜蘭": {
    "lat": 24.75,
    "lng": 121.75
  },
  "澎湖": {
    "lat": 23.57,
    "lng": 119.57
  },
  "金門": {
    "lat": 24.44,
    "lng": 118.37
  },
  "馬祖": {
    "lat": 26.15,
    "lng": 119.93
  },
  "香港": {
    "lat": 22.31,
    "lng": 114.16
  },
  "澳門": {
    "lat": 22.19,
    "lng": 113.54
  },
};
export default cityCoordinates;
export { cityCoordinates };
